export default "__VITE_ASSET__DyWTVkR0__"